import { render, staticRenderFns } from "./BuildStep.vue?vue&type=template&id=28788bd2"
import script from "./BuildStep.vue?vue&type=script&lang=js"
export * from "./BuildStep.vue?vue&type=script&lang=js"
import style0 from "./BuildStep.vue?vue&type=style&index=0&id=28788bd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports